export default [{
	name: 'Fédération\nsuisse du tourisme\nFST',
	children: [{
        name: 'Partenaires des projets',
        children: [
            { name: 'Haute-école \nspécialisée bernoise' },
            { name: 'Haute-école zurichoise \nde sciences appliquées ZHAW' },
            { name: 'ibex fairstay' },
            { name: 'Myclimate' },
        ]
    }, {
        name: 'Bundesverwaltung',
        children: [
            { name: 'Office fédéral \nde la statistique \nOFS' },
            { name: 'Office fédéral \nde l’environnement \nOFEV' },
            { name: 'Office fédéral \ndu développement territorial \nARE' },
            { name: 'Office fédéral \ndu sport OFSPO' },
            { name: 'Secrétariat d’Etat \nà la formation, \nà la recherche et \nà l’innovation SEFRI' },
            { name: 'Secrétariat d’Etat \nà l’économie SECO' },
            { name: 'Société Suisse \nde Crédit Hôtelier' },
            { name: 'Suisse Tourisme' },
        ]
    }, {
        name: 'Politique',
        children: [
            { name: 'Conférence des chefs \ndes départements cantonaux \nde l’économie publique' },
            { name: 'Conférence gouvernementale \ndes cantons alpins' },
            { name: 'Groupe de suivi \nStratégie touristique \nde la Confédération' },
            { name: 'Groupe parlementaire \naéronautique et \naérospatiale' },
            { name: 'Groupe parlementaire \npour le tourisme' },
            { name: 'Intergroupe parlementaire Travail' },
            { name: 'Litra' },
        ]
    }, {
        name: 'Formation touristique',
        children: [
            { name: 'Centre de formation \nd’Interlaken bzi' },
            { name: 'Centre de formation \nFeusi' },
            { name: 'Centre valaisan \nde perfectionnement' },
            { name: 'École Athena' },
            { name: 'École internationale \ndu tourisme IST' },
            { name: 'École supérieure de \ntourisme de Lucerne HFT' },
            { name: 'Haute-école de \nLucerne HSLU' },
            { name: 'Haute-école du \nValais HES-SO' },
            { name: 'Sous-conférence \ndes écoles supérieures \nde tourisme' },
        ]
    }, {
        name: 'Autres organisations',
        children: [
            { name: 'Direction générale \ndu projet Statistique \nde l’hébergement' },
            { name: 'Groupe consultatif fédéral \nsur le label de produits Parcs' },
        ]
    }, {
        name: 'Associations sectorielles \net organisations',
        children: [
            { name: 'Association suisse \npour l’aménagement national' },
            { name: 'Association \n«Suisse sans obstacles»',
                children: [
                    { name: 'Association suisse \ndes paraplégiques'},
                    { name: 'Bureau fédéral \nde l’égalité pour \nles personnes handicapées' },
                    { name: 'Fondation «Denk an mich»' },
                    { name: 'Pro Infirmis' },
                ]
            },
            { name: 'Fondation suisse \npour la protection et \nl’aménagement du paysage' },
            { name: 'Groupement suisse \npour les régions \nde montagne' },
            { name: 'Initiative en faveur \ndes sports de neige',
                children: [
                    { name: 'Association faîtière \ndes enseignantes et \ndes enseignants suisses LCH'},
                ]
            },
            { name: 'routesuisse' },
            { name: 'Verband Schweizerische \nLandesplanung SL' },
            { name: 'senesuisse' },
            { name: 'Swiss Association \nfor Quality SAQ' },
        ]
    }, {
        name: 'Associations et \norganisations touristiques',
        children: [
            { name: 'Agrotourisme Suisse' },
            { name: 'Association Suisse \ndes Managers en tourisme' },
            { name: 'Auberges de \nJeunesse Suisses' },
            { name: 'Bed and Breakfast \nSwitzerland' },
            { name: 'Car Tourisme Suisse,\nCar-Groupe ASTAG' },
            { name: 'CI Neige' },
            { name: 'Conférence des directeurs \nd’offices de tourisme \nrégionaux de Suisse',
                children: [
                    { name: '13 régions touristiques',
                        children: [
                            { name: 'Destinations touristiques'},
                        ]
                    },
                ]
            },
            { name: 'GastroSuisse' },
            { name: 'Groups' },
            { name: 'Hotel & \nGastro Union' },
            { name: 'hotelleriesuisse' },
            { name: 'Interhome' },
            { name: 'Parahôtellerie Suisse' },
            { name: 'Reka' },
            { name: 'Remontées Mécaniques Suisses' },
            { name: 'Réseau des parcs suisses' },
            { name: 'Safety in adventures' },
            { name: 'SuisseMobile' },
            { name: 'Swiss Snowsports' },
            { name: 'Union des transports publics' },
        ]
    }, {
        name: 'Prix touristiques / Jurys / Patronages',
        children: [
            { name: 'Camp Tourisme Suisse' },
            { name: 'Fête de la Nature' },
            { name: 'Forum Tourisme Suisse' },
            { name: 'Générateur d’innovation' },
            { name: 'Milestone' },
            { name: 'Prix de l’innovation \nde l’Oberland bernois' },
            { name: 'Prix Rando' },
            { name: 'Swiss Holiday Home Award' },
        ]
    }, {
        name: 'Science',
        children: [
            { name: 'Institut de management systémique \net de gouvernance publique \nIPM-HSG' },
            { name: 'Institut pour le tourisme \nde Coire ITW' },
            { name: 'Observatoire Valaisan \ndu Tourisme' },
            { name: 'Unité de recherche \nen tourisme CRED-T \nUniversité de Berne' },
        ]
    }]
}];